module.exports = __webpack_public_path__ + "img/invoice.39595ce6.jpeg";